import {CustomerBookingDetails} from "./customer.types";
import {MerchantPlatformSettings} from "./payment.types";

export interface OpportunityDetails {
    id: number;
    priceExpirationDate?: Date;
    firstAvailablePickupDate: Date;
    transportType: string;
    vehicles?: string;
    price: BookingPrice;
    customer: CustomerBookingDetails;
    origin: Location;
    destination: Location;
    specialTerms?: string;
    commentFromShipper?: string;
    clientIp?: string;
    isPaymentStepRequired: boolean;
    signatureDate?: Date;
    merchantPlatformCredentials?: MerchantPlatformSettings;
}

export interface Location {
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    userFriendlyAddress?: string;
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactPhone2?: string;
    contactPhone3?: string;
    contactPhoneCell?: string;
}

export interface BookingPrice {
    totalPrice: number;
    payments: BookingPayment[];
}

export interface BookingPayment {
    key: string;
    value: string;
}

export interface OrderBookingRequest {
    firstName: string;
    lastName: string;
    company?: string;
    email: string;
    email2?: string;
    phone: string;
    phone2?: string;
    firstAvailablePickup: Date;
    origin?: LocationBookingRequest;
    destination?: LocationBookingRequest;
}

export interface LocationBookingRequest {
    address?: string;
    address2?: string;
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactPhone2?: string;
    contactPhone3?: string;
    contactPhoneCell?: string;
}

export enum BookingErrorDetail {
    UniqueConstraintViolation = 'UniqueConstraintViolation'
}

export type OpportunityType = 'quotes' | 'orders';

export interface OrderBookingResponse {
    signatureDate: Date;
}
